module.exports = __webpack_public_path__ + "static/media/RenaultLifeWeb-Regular.245e98d8.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/renault-life/RenaultLifeWeb-Regular.woff
// module id = 925
// module chunks = 0